import React, { FC, ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  compact?: boolean;
};

export const ProfileWidgetEmptyState: FC<Props> = ({
  icon,
  title,
  description,
  action,
  compact,
}) => {
  return (
    <div
      className={
        "flex min-h-[210px] flex-col items-center justify-center px-6 py-8 text-center"
      }>
      <span
        className={`inline-flex items-center justify-center rounded-full bg-[#F4F2FF] text-[#A99DE8] ${
          compact ? "mb-3 h-[54px] w-[54px]" : "mb-3.5 h-16 w-16"
        }`}>
        {icon}
      </span>
      <span className={"text-sm font-semibold text-[#5F758F]"}>{title}</span>
      {description && (
        <span
          className={
            "mt-1 max-w-[280px] text-[12.5px] font-medium leading-[1.45] text-[#8A92A3]"
          }>
          {description}
        </span>
      )}
      {action && <span className={"mt-3"}>{action}</span>}
    </div>
  );
};
